// Time constants
export const RESEND_SUCCESS_DISPLAY_DURATION = 3000;
export const COUNTDOWN_INTERVAL = 1000;
export const LOCKOUT_UPDATE_INTERVAL = 60000;

// Error types
export const ERROR_TYPES = {
  INVALID_CODE: 'INVALID_CODE',
  CODE_EXPIRED: 'CODE_EXPIRED',
  CODE_ALREADY_USED: 'CODE_ALREADY_USED',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  ACCOUNT_LOCKED_MAX_ATTEMPTS: 'ACCOUNT_LOCKED_MAX_ATTEMPTS',
  EMAIL_IN_USE: 'EMAIL_IN_USE',
  NEW_EMAIL_IN_USE: 'NEW_EMAIL_IN_USE',
  EMAIL_ALREADY_VERIFIED: 'EMAIL_ALREADY_VERIFIED',
  EXPIRED_TOKEN: 'EXPIRED_TOKEN',
  TOKEN_REQUIRED: 'TOKEN_REQUIRED',
  VERIFICATION_NOT_FOUND: 'VERIFICATION_NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  NEW_EMAIL_DIFFERENT_FROM_CURRENT_EMAIL:
    'NEW_EMAIL_DIFFERENT_FROM_CURRENT_EMAIL',
  RESEND_THROTTLE: 'RESEND_THROTTLE',
};

// Verification types
export const VERIFICATION_TYPES = {
  SIGN_UP: 'SIGN_UP',
  EMAIL_CHANGE: 'EMAIL_CHANGE',
};

// Component types
export const COMPONENT_TYPES = {
  MODAL: 'MODAL',
  PAGE: 'PAGE',
};
